import React, { ReactElement, useContext } from 'react';

import FileMessageBubble from '../../../../../mobile/scenes/channel/components/messageTypes/FileMessageBubble';
import { ChatContext } from '../../../../../mobile/scenes/channel/types';

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function FileMessage({ message, disabled }): ReactElement {
  const { handleSelectingMessage } = useContext(ChatContext);

  return (
    <FileMessageBubble
      message={message}
      onLongPress={handleSelectingMessage}
      disabled={disabled}
    />
  );
}
